
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire104b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire104b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $f8acdf6f324bec7e$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["9vqfN","index.aea33d85.js","jsHlA","service-worker.js","6WvQD","latigra.97fc8e1b.geojson"]'));

var $2857dc952d963d0e$exports = {};
$2857dc952d963d0e$exports = new URL("service-worker.js", import.meta.url).toString();


if ("serviceWorker" in navigator) window.addEventListener("load", async ()=>{
    try {
        const registration = await navigator.serviceWorker.register($2857dc952d963d0e$exports);
        console.log("ServiceWorker registration successful with scope: ", registration.scope);
    } catch (error) {
        console.log("ServiceWorker registration failed: ", error);
    }
});
const $35da740d59af89ba$var$styleJson = `https://api.maptiler.com/maps/23fc4bc6-8298-4acd-bf38-b54a2bedc7ea/style.json?key=tCm4ufit3cvrDyoH811u`;
const $35da740d59af89ba$var$attribution = new ol.control.Attribution({
    collapsible: true
});
var $15a289a609989469$exports = {};
$15a289a609989469$exports = new URL("latigra.97fc8e1b.geojson", import.meta.url).toString();


async function $35da740d59af89ba$var$loadGeoJSON(olms1) {
    try {
        const tooltip = document.getElementById("tooltip_custom");
        const response = await fetch(new URL($15a289a609989469$exports));
        const geojsonObject = await response.json();
        // Create a vector source from the GeoJSON object
        const vectorSource = new ol.source.Vector({
            features: new ol.format.GeoJSON().readFeatures(geojsonObject, {
                featureProjection: "EPSG:3857" // This is the default projection used by OpenLayers
            })
        });
        // Create vector layers for suppliers and warehouses
        const supplierLayer = new ol.layer.Vector({
            source: new ol.source.Vector({
                features: vectorSource.getFeatures().filter((feature)=>feature.id_ === "U2MDY1")
            }),
            style: $35da740d59af89ba$var$styleFunction1,
            zIndex: 10 // Ensure the vector layer is on top
        });
        // Create a vector layer to display the features
        const vectorLayer = new ol.layer.Vector({
            source: vectorSource,
            style: $35da740d59af89ba$var$styleFunction,
            zIndex: 10
        });
        // Create a map and add the vector layer to it
        const map = new ol.Map({
            target: "map",
            controls: ol.control.defaults.defaults({
                attribution: false
            }).extend([
                $35da740d59af89ba$var$attribution
            ]),
            layers: [
                new ol.layer.Tile({
                    source: new ol.source.OSM()
                }),
                vectorLayer,
                supplierLayer
            ],
            view: new ol.View({
                constrainResolution: true,
                center: ol.proj.fromLonLat([
                    -84.577414,
                    10.343776
                ]),
                zoom: 17
            })
        });
        const showTooltip = (evt)=>{
            tooltip.style.display = "none"; // Hide tooltip by default
            // Detect feature at the cursor
            map.forEachFeatureAtPixel(evt.pixel, function(feature) {
                const featureName = feature.get("name"); // Get the 'name' property
                if (featureName && featureName != "perimeter") {
                    tooltip.innerHTML = featureName; // Set tooltip text
                    tooltip.style.display = "block"; // Display tooltip
                    tooltip.style.left = `${evt.pixel[0] + 10}px`; // Position tooltip with offset
                    tooltip.style.top = `${evt.pixel[1] + 10}px`;
                }
            });
        };
        map.on("pointermove", showTooltip); // Desktop hover
        map.on("pointerdown", showTooltip); // Mobile tap
        map.on("touchstart", showTooltip); // Mobile touch
        // Optional: Hide tooltip when the mouse leaves the map
        map.getViewport().addEventListener("mouseout", ()=>{
        // tooltip.style.display = 'none';
        });
    // add style
    // olms.apply(map);
    } catch (error) {
        console.error("Error loading the GeoJSON file:", error);
    }
}
$35da740d59af89ba$var$loadGeoJSON(olms);
// Function to apply styles based on feature properties
const $35da740d59af89ba$var$styleFunction = (feature)=>{
    return new ol.style.Style({
        fill: new ol.style.Fill({
            color: "rgba(104, 163, 63, 0.3)"
        }),
        stroke: new ol.style.Stroke({
            color: "green",
            width: 1
        })
    });
};
const $35da740d59af89ba$var$styleFunction1 = (feature)=>{
    return new ol.style.Style({
        fill: new ol.style.Fill({
            color: "rgba(0, 0, 255, 0.3)"
        }),
        stroke: new ol.style.Stroke({
            color: "green",
            width: 1
        })
    });
};


//# sourceMappingURL=index.aea33d85.js.map
